import { Card, Typography } from "@mui/material";
import React from "react";

const ErrorMessage = () => {
  return (
    <Card
      sx={{
        height: "500px",
        width: "100%",
        display: "grid",
        placeItems: "center",
        mt: "20px",
        mr: "90px",
      }}
      elevation={3}
    >
      <Typography variant="h4">Some Error Occurred</Typography>
    </Card>
  );
};

export default ErrorMessage;
